import axios from '@axios'

const route = 'reserve/reserve'
export default {
  namespaced: true,
  state: {
    guests: [],
    guestsUnknown: [],

  },
  getters: {
    getGuests(state) {
      return state.guests.concat(state.guestsUnknown)
    },

  },
  mutations: {
    setGuests(state, guests) {
      state.guests = guests
    },
    setGuestsUnknown(state, guests) {
      guests.forEach(guest => {
        guest.origin = 'unknown'
      })

      state.guestsUnknown = guests
    },

    addGuest(state, guest) {
      const result = state.guests.find(item => item.id == guest.id)
      if (!result) {
        state.guests.push(guest)
      }
    },

    addGuestUnknown(state, guestUnknown) {
      state.guestsUnknown.push(guestUnknown)
    },

    removeGuest(state, guest) {
      const index = state.guests.indexOf(guest)
      state.guests.splice(index, 1)
    },

    removeUnknown(state, unknown) {
      const index = state.guestsUnknown.indexOf(unknown)
      state.guestsUnknown.splice(index, 1)
    },

  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, filter,
    }) {
      return axios.post(`reserve/index?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filter)
    },
    getCompletedReserve(context, {
      itemsPerPage, page, search, filter,
    }) {
      return axios.post(`reserve/completed_reserve?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filter)
    },
    getGroupReserve(context, {
      itemsPerPage, page, search, filter,
    }) {
      return axios.get(`reserve/group_reserve?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filter)
    },
    getGroupAccount(context, groupId) {
      return axios.get(`reserve/group_reserve/${groupId}/account`)
    },
    getGroupAccountRoomLines(context, { accountId, accommodationId }) {
      return axios.get(`reserve/group_account/${accountId}/room/${accommodationId}/lines`)
    },
    createGroupAccount(context, { groupId, data }) {
      return axios.post(`reserve/group_reserve/${groupId}/account`, data)
    },
    getGroupJoinCandidates(context, groupId) {
      return axios.get(`reserve/group_reserve/${groupId}/join_candidates`)
    },
    getGroupCreationCandidates() {
      return axios.get('reserve/group_reserve_candidates')
    },
    createGroupFromReservations(context, data) {
      return axios.post('reserve/group_reserve_from_reservations', data)
    },
    attachReservationsToGroup(context, { groupId, reserveIds }) {
      return axios.post(`reserve/group_reserve/${groupId}/reservations`, { reserve_ids: reserveIds })
    },
    addGroupAccountPayment(context, { accountId, data }) {
      return axios.post(`reserve/group_account/${accountId}/payments`, data)
    },
    removeGroupAccountPayment(context, {
      accountId, allocationId, justification,
    }) {
      return axios.delete(`reserve/group_account/${accountId}/payments/${allocationId}`, { data: { justification } })
    },
    updateGroupAccountAdjustments(context, { accountId, data }) {
      return axios.put(`reserve/group_account/${accountId}/adjustments`, data)
    },
    changeGroupAccountCompany(context, { accountId, data }) {
      return axios.put(`reserve/group_account/${accountId}/company`, data, { headers: { callbackerror: true } })
    },
    detachGroupAccountCheckout(context, { checkoutId, justification }) {
      return axios.post(`manager_room/checkout/${checkoutId}/detach_group_account`, { justification })
    },
    closeGroupAccount(context, accountId) {
      return axios.post(`reserve/group_account/${accountId}/close`)
    },
    reopenGroupAccount(context, accountId) {
      return axios.post(`reserve/group_account/${accountId}/reopen`)
    },
    sendGroupAccountToGestao(context, accountId) {
      return axios.post(`manager_room/group_account/${accountId}/send_to_gestao`)
    },
    exportGroupAccountVoucher(context, accountId) {
      return axios.get(`reserve/group_account/${accountId}/voucher`, { responseType: 'blob' })
    },
    store({ state }, reserve) {
      reserve.guest = state.guests
      reserve.guest_unknown = state.guestsUnknown

      return axios.post(route, reserve)
    },
    update({ state }, reserve) {
      reserve.guest = state.guests
      reserve.guest_unknown = state.guestsUnknown

      return axios.put(`${route}/${reserve.id}`, reserve)
    },
    cancelReserve(context, data) {
      return axios.post(`reserve/delete/${data.id}`, data)
    },
    confirmReserve(context, data) {
      return axios.post(`reserve/confirm/${data.id}`)
    },
    getRooms(context) {
      return axios.get('helper/get_rooms')
    },
    printVoucher(context, reserve) {
      return axios.get(`reserve/reserve_voucher_export_pdf/${reserve.id}`, { responseType: 'blob' })
    },
    printGuestSheets(context, reserve) {
      return axios.get(`reserve/reserve_guests_pdf/${reserve.id}`, { responseType: 'blob' })
    },
    printGuestSheetsPreview(context, { reserveId, guestIds }) {
      return axios.post(`reserve/reserve_guests_pdf_preview/${reserveId}`, { guest_ids: guestIds }, { responseType: 'blob' })
    },
    getReserveItems(context, reserve) {
      return axios.get(`reserve/reserve_items/${reserve.id}`)
    },

    verifyRoom(context, params) {
      return axios.post('reserve/verify_room', params)
    },

    availableRoomsForAssignment(context, reserveId) {
      return axios.post(`reserve/available_rooms/${reserveId}`)
    },
    assignRoom(context, data) {
      return axios.post(`reserve/assign_room/${data.reserve_id}`, { room_id: data.room_id })
    },

    resendVoucher(context, data) {
      return axios.post(`reserve/resend_voucher/${data.reserve_id}`, { email: data.email })
    },
    resendWhatsVoucher(context, data) {
      return axios.post(`reserve/resend_voucher_whats/${data.reserve_id}`, { whats: data.whats })
    },

    // Retorna os caixas abertos
    getOpenedCashs(context) {
      return axios.get('helper/get_opened_cashs')
    },

    // Retorna o usuario logado
    getUser(context) {
      return axios.get('helper/get_user')
    },
    reOpen(context, data) {
      return axios.post(`reserve/re_open/${data.id}`)
    },
    findReserve(context, data) {
      return axios.post('reserve/find_reserve', data)
    },

  },
}
